import { render, staticRenderFns } from "./ActiveArticles.vue?vue&type=template&id=55709eac&scoped=true&"
import script from "./ActiveArticles.vue?vue&type=script&lang=js&"
export * from "./ActiveArticles.vue?vue&type=script&lang=js&"
import style0 from "./ActiveArticles.vue?vue&type=style&index=0&id=55709eac&prod&lang=css&"
import style1 from "./ActiveArticles.vue?vue&type=style&index=1&id=55709eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55709eac",
  null
  
)

export default component.exports